var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainbody"},[_c('div',{staticClass:"card"},[_vm._m(0),_c('h1',[_vm._v("Success")]),_c('p',[_vm._v(" Your bid of Rs "+_vm._s(_vm._f("currency")(_vm.bidAmount))+" has been successfully submitted. ")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"innercr"},[_c('i',{staticClass:"checkmark"},[_vm._v("✓")])])
}]

export { render, staticRenderFns }